import { LocationTypeEnum } from '../places/model';

export interface ILastViewedPlace {
  id: string;
  name: string;
  slug: string;
  organization: string;
  mainType: EMainType;
  subType: LocationTypeEnum | 'Collection';
}

export interface INotification {
  text: string;
}

export interface IWorkspaces {
  text: string[];
}

export enum EMainType {
  LOCATION = 'LOCATION',
  COLLECTION = 'COLLECTION',
  ELSA_MAP = 'ELSA_MAP',
}

// There is not way to extend enums, this is a workaround
export const SubType = {
  ...LocationTypeEnum,
  COLLECTION: 'collection',
};
